"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountType = void 0;
var DiscountType;
(function (DiscountType) {
    DiscountType["Percentage"] = "Percentage";
    DiscountType["FixedAmount"] = "FixedAmount";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
//# sourceMappingURL=discount-type.js.map